module.exports = __webpack_public_path__ + "img/banner-26.47a61bf4.jpg";